export const backendBaseUrl = import.meta.env.REACT_APP_BACKEND_URL || "";
if (!Boolean(backendBaseUrl)) console.log("Missing REACT_APP_BACKEND_URL var");

export const cmsBaseUrl = import.meta.env.REACT_APP_CMS_URL || "";
if (!Boolean(cmsBaseUrl)) console.log("Missing REACT_APP_CMS_URL var");
